import { defineStyleConfig } from "@chakra-ui/react";


export const ButtonStyle = defineStyleConfig({
  variants: {
    drawerMenuButton:{
      
      padding:"30px 90px",
      _hover:{
        bg:"gray.300"
      }
    },
    connect: {
      outline:`1px #7950DD solid`,
      color: "white",
      borderRadius:"full",
      padding:"0 25px",
      _hover: {
        opacity: "1",
        bg: "#7950DD",
        outline:`1px #7950DD solid`,
      },
    },
    nav:{
      opacity:'0.7',
      color:"#fff",
      _hover:{
        opacity:"1",
      },
      _active:{
        bg:"#fff",
        color:"#000",
        opacity:"1"
      }
    },
    mint:{
      bg:"#03C988",
      color:"white",
      _hover:{

      }
      ,opacity:"1"
    },
    metamask: {
      borderRadius: "5px",
      bg: "#fff",
      color: "black",
      opacity: 0.8,
      _hover: {
        bg:'gray.200',
        opacity: 1,
      },
    },
    wallet:{
      color:"white",
      outline:`1px #7950DD solid`,
      color: "white",
      borderRadius:"full",
      padding:"5px 10px 5px 5px",
      _hover: {
        opacity: "1",
        bg: "#7950DD",
        outline:`1px #7950DD solid`,
      },
    }
  },
});
